import React from 'react';

/**
 * Texte d'une réponse du bot, mis en forme pour l'écran.
 *
 * Les rubriques sont écrites pour WhatsApp: une idée par ligne, *gras* entre
 * astérisques, émojis en tête de ligne. On garde exactement ce texte (même
 * réponse sur WhatsApp et dans l'application) et on ne fait que trois choses:
 * le gras devient <strong>, chaque ligne reste une ligne, une ligne vide crée
 * un léger espace. Aucun HTML venu du serveur n'est interprété.
 */
const GRAS = /\*([^*\n]+)\*/g;

const enLigne = (ligne, cle) => {
  const morceaux = [];
  let dernier = 0;
  let trouve;
  GRAS.lastIndex = 0;
  while ((trouve = GRAS.exec(ligne)) !== null) {
    if (trouve.index > dernier) morceaux.push(ligne.slice(dernier, trouve.index));
    morceaux.push(
      <strong key={`${cle}-${trouve.index}`} className="font-semibold text-foreground">
        {trouve[1]}
      </strong>,
    );
    dernier = trouve.index + trouve[0].length;
  }
  if (dernier < ligne.length) morceaux.push(ligne.slice(dernier));
  return morceaux;
};

export function TexteAssistant({ texte, titre = false }) {
  const lignes = String(texte || '').split('\n');
  return (
    <div className="space-y-0.5 break-words">
      {lignes.map((ligne, index) =>
        ligne.trim() === '' ? (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className="h-1.5" aria-hidden="true" />
        ) : (
          // eslint-disable-next-line react/no-array-index-key
          <p key={index} className={titre && index === 0 ? 'pb-1 font-semibold leading-relaxed text-foreground' : 'leading-relaxed'}>
            {enLigne(ligne, index)}
          </p>
        ),
      )}
    </div>
  );
}

export default TexteAssistant;
